import { faShieldCheck } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { SUPPORT_ADMIN_ROUTE } from "../../../../../../constants/routes"
import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    container: {
        borderRadius: ".75rem",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: `1px solid ${theme.palette.tailwind.slate[200]}`,
    },
    iframe: {
        width: "100%",
        height: "70vh",
        border: "none",
        overflow: "auto",
    },
}))

export function DatabaseHealth() {
    const { classes } = useStyles()

    return (
        <>
            <LocalizedStrict id="support-reports-health-database-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.SUPPORT_ADMIN_HEALTH_DATABASE_HEALTH}
                    title="Server memory"
                    icon={<FontAwesomeIcon icon={faShieldCheck} />}
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="support-nav-item-home">
                            <BreadcrumbLink to={SUPPORT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="support-nav-item-health">
                            <Breadcrumb>Health</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="support-nav-item-health-database">
                            <Breadcrumb>Database health</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <Box className={classes.container}>
                <iframe
                    src="https://bestil-nu.net/servlet/AdminDBPool"
                    className={classes.iframe}
                    title="Database Health Monitor"
                />
            </Box>
        </>
    )
}
